module.exports = __webpack_public_path__ + "static/media/grapefruit-1.c908963f.png";